import * as React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  Modal,
  ModalBody,
  ModalFooter
} from '@contrast-security-inc/design-system-popovers'
import { IconHelp } from '@contrast-security-inc/design-system-foundations'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { Button } from '@contrast-security-inc/design-system-buttons'
import { useIntl } from 'react-intl'
import { formatStyles } from '../../../components/react-intl-helpers'

export function NoAssessServersModal({
  isOpen,
  close
}: {
  isOpen: boolean
  close: () => void
}) {
  const { formatMessage } = useIntl()

  return isOpen ? (
    <Modal
      testId="no-assess-servers-modal"
      onClose={close}
      isOpen={true}
      Icon={IconHelp}
      size="md"
      title={formatMessage({ id: 'title_appDashboard_noServersDefined' })}
      variant="info"
    >
      <ModalBody>
        <Text font="body">
          {formatMessage(
            {
              id: 'detail_appOverview_turnOnAssessModal'
            },
            {
              ...formatStyles.anchor,
              a: (...msg) => (
                <Link
                  href={formatMessage({
                    id: 'detail_appOverview_turnOnAssessModal_link'
                  })}
                  isExternal
                >
                  {msg}
                </Link>
              )
            }
          )}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" onClick={close}>
          {formatMessage({ id: 'action_close' })}
        </Button>
      </ModalFooter>
    </Modal>
  ) : (
    <></>
  )
}

export const reactNoAssessServersModal = createNgReactBridgeDirective(
  'reactNoAssessServersModal',
  [],
  NoAssessServersModal,
  ['isOpen', 'close']
)
